import moment from "moment";
import { ISearchLimitOffset } from "./ISearchLimitOffset";

export interface IFilterCompte extends ISearchLimitOffset {
    //changer les numbers avec | null pour que dans les input on affiche pas 0 lorsque le champs vide (changer avec le meme comportement de LPE)
    Id?: number | null;
    NomPrenom?: string;
    Email?: string;
    DateDebut?: Date;
    DateFin?: Date;
    IdEtatUtilisateur?: string;
    IdTypeUtilisateur?: string;
    SortField?: string;
    IsDescending?:boolean;
  }

  export interface IFilterCompteDTO extends ISearchLimitOffset {
    //changer les numbers avec | null pour que dans les input on affiche pas 0 lorsque le champs vide (changer avec le meme comportement de LPE)
    Id?: number | null,
    NomPrenom: string,
    Email: string,
    DateDebut: string,
    DateFin: string,
    IdEtatUtilisateur: string,
    IdTypeUtilisateur: string,
    SortField: string,
    IsDescending:boolean
}
  
  export const getDefaultFilterCompte = (): IFilterCompte => ({
    //changer les numbers avec | null pour que dans les input on affiche pas 0 lorsque le champs vide (changer avec le meme comportement de LPE)
    Id: null,
    NomPrenom: undefined,
    Email: undefined,
    IdEtatUtilisateur: undefined,
    IdTypeUtilisateur: undefined,
    DateDebut: undefined,
    DateFin: undefined,
    Limit: 10,
    Offset: 0,
    SortField: "Nom",
    IsDescending: true
  });

  export const dtoToFilter = (dto: IFilterCompteDTO): IFilterCompte => {
  
    return {
        Id: dto.Id,
        NomPrenom: dto.NomPrenom,
        Email: dto.Email,
        IdEtatUtilisateur: dto.IdEtatUtilisateur,
        IdTypeUtilisateur: dto.IdTypeUtilisateur,
        DateDebut: dto.DateDebut ? new Date(dto.DateDebut) : undefined,
        DateFin: dto.DateFin ? new Date(dto.DateFin) : undefined,
        Limit: dto.Limit !== undefined ? dto.Limit : 10,
        Offset: dto.Offset !== undefined ? dto.Offset : 0,
    };
  };

  export const filterToQuery = (filter: IFilterCompte): IFilterCompteDTO => {
    const dto: IFilterCompteDTO = {
      //changer les numbers avec | null pour que dans les input on affiche pas 0 lorsque le champs vide (changer avec le meme comportement de LPE)
        Id: null,
        NomPrenom: "",
        Email: "",
        DateDebut: "",
        DateFin: "",
        IdEtatUtilisateur: "",
        IdTypeUtilisateur: "",
        SortField: "",
        IsDescending: false
    };
 
    if (filter?.Id !== undefined ) {
      dto.Id = filter.Id;
    } 

    if (filter?.NomPrenom !== undefined ) {
      dto.NomPrenom = filter.NomPrenom;
    } 

    if (filter?.Email !== undefined ) {
      dto.Email = filter.Email;
    } 

    if (filter?.IdEtatUtilisateur !== undefined ) {
      dto.IdEtatUtilisateur = filter.IdEtatUtilisateur;
    } 

    if (filter?.IdTypeUtilisateur !== undefined ) {
        dto.IdTypeUtilisateur = filter.IdTypeUtilisateur;
    } 

    if (filter.DateDebut) {
        if (filter.DateDebut instanceof Date) {
            // Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
            dto.DateDebut = moment(new Date(filter.DateDebut?.getFullYear(),filter.DateDebut?.getMonth(),filter.DateDebut?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        } else {
            dto.DateDebut = filter.DateDebut;
        }
        
    }
    if (filter.DateFin) {
        if (filter.DateFin instanceof Date) {
            //Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
            dto.DateFin = moment(new Date(filter.DateFin?.getFullYear(),filter.DateFin?.getMonth(),filter.DateFin?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        } else {
            dto.DateFin = filter.DateFin;
        }
    }


    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }
  
    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }

    localStorage.setItem("IFilterComptes", JSON.stringify(dto));
  
    return dto;
  };